module.exports = __webpack_public_path__ + "static/customer-dispute-management@2x-6f0f23a253df9a9363a03e195518af52.png";